// removed by extract-text-webpack-plugin
module.exports = {"root":"fdb59905"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileAppLogo/styles.styl
// module id = 5019
// module chunks = 39